import app from "../firebase";
import { db } from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { collection, getDocs } from "firebase/firestore";

const portalServiceUnavailableMessage =
  "Portal şifreleme servisi şu anda kullanılamıyor. Firebase projesinin Cloud Billing bağlantısını kontrol edin.";

const callPortalAction = async (portalAction, data = {}) => {
  try {
    const callable = httpsCallable(
      getFunctions(app, "us-central1"),
      "createUser"
    );
    return (await callable({ portalAction, ...data })).data;
  } catch (error) {
    if (String(error?.code || "").includes("internal") || error?.message === "internal") {
      const serviceError = new Error(portalServiceUnavailableMessage);
      serviceError.code = "portal-service-unavailable";
      throw serviceError;
    }
    throw error;
  }
};

export const listPortalCredentials = async () => {
  try {
    return await callPortalAction("list");
  } catch (error) {
    if (error?.code !== "portal-service-unavailable") throw error;

    const snapshot = await getDocs(collection(db, "portalCredentials"));
    const fallbackCredentials = snapshot.docs
      .map((document) => {
        const data = document.data();
        return {
          id: document.id,
          technoparkName: data.technoparkName || "",
          portalUrl: data.portalUrl || "",
          username: data.username || "",
          description: data.description || "",
          createdAt: data.createdAt?.toDate?.().toISOString() || null,
          updatedAt: data.updatedAt?.toDate?.().toISOString() || null,
          serviceUnavailable: true
        };
      })
      .sort((first, second) => first.technoparkName.localeCompare(second.technoparkName, "tr"));
    fallbackCredentials.serviceUnavailable = true;
    return fallbackCredentials;
  }
};

export const savePortalCredential = async (credential) => {
  return callPortalAction("save", credential);
};

export const revealPortalCredentialPassword = async (id) => {
  return (await callPortalAction("reveal", { id })).password;
};

export const deletePortalCredential = async (id) => {
  return callPortalAction("delete", { id });
};

export const importPortalCredentials = async (rows) => {
  return callPortalAction("import", { rows });
};
